export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10335.10d833d7.jpg";